import React from "react";
import { Lightbulb, AlertTriangle } from "lucide-react";

interface CalloutProps {
  type: "tip" | "warning";
  children: React.ReactNode;
}

const baseClasses = "p-4 rounded-md border flex items-start";
const typeClasses = {
  tip: "bg-blue-50 border-blue-200 text-blue-800",
  warning: "bg-yellow-50 border-yellow-200 text-yellow-800",
};

export const Callout: React.FC<CalloutProps> = ({ type, children }) => {
  const Icon = type === "tip" ? Lightbulb : AlertTriangle;
  const iconColorClass = type === "tip" ? "text-blue-500" : "text-yellow-500";

  return (
    <div className={`${baseClasses} ${typeClasses[type]}`}>
      <Icon className={`w-5 h-5 mr-2 ${iconColorClass}`} strokeWidth={2.5} />
      <div className="flex-1">{children}</div>
    </div>
  );
};
